import { Injectable } from '@angular/core';
import { EndpointParams } from '@models/utils/endpoint-params';
import { HttpService } from '@services/http.service';
import { ContractDetail } from '@models/index';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActionTask } from '@enumerates/index';

@Injectable({
    providedIn: 'root'
})
export class MemberTasksService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'member', version: 2 };

    private memberTaskSubject = new BehaviorSubject<ContractDetail[]>([]);
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { tasks: ContractDetail[] } = { tasks: [] };

    readonly tasks = this.memberTaskSubject.asObservable();
    readonly loading = this.isLoadingDataSubject.asObservable();

    list(ianaZone: string): void {
        this.setLoading(true);
        this.listTasks(ianaZone).subscribe(
            result => {
                if (result) {
                    this.next();
                }

                this.setLoading(false);
            }
        );
    }

    private listTasks(ianaZone: string): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.dataStore.tasks = [];
                this.get('customer/services/schedules/me', { app: 'member', version: 3 }).subscribe(
                    data => {
                        if (data) {
                            data.forEach(
                                (task: any) => {
                                    if (task.action === ActionTask.task || task.action === ActionTask.service || task.action === ActionTask.serviceVideoChat){
                                        this.dataStore.tasks.push(new ContractDetail().buildFromContract(task, ianaZone));
                                    }
                                }
                            );
                        }

                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(): void {
        this.memberTaskSubject.next([...this.dataStore.tasks]);
    }

    private setLoading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
